var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeightTemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33464 13.9993C4.70283 13.9993 5.0013 13.7009 5.0013 13.3327C5.0013 12.9645 4.70283 12.666 4.33464 12.666C3.96645 12.666 3.66797 12.9645 3.66797 13.3327C3.66797 13.7009 3.96645 13.9993 4.33464 13.9993Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33203 4V12.6667",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 1.66634C5.66667 1.31272 5.52619 0.973581 5.27614 0.723532C5.02609 0.473484 4.68696 0.333008 4.33333 0.333008C3.97971 0.333008 3.64057 0.473484 3.39052 0.723532C3.14048 0.973581 3 1.31272 3 1.66634V11.4197C2.59234 11.7035 2.28591 12.1101 2.12531 12.5802C1.96471 13.0502 1.95832 13.5593 2.10708 14.0333C2.25583 14.5072 2.55197 14.9213 2.95238 15.2153C3.35279 15.5093 3.83658 15.6679 4.33333 15.6679C4.83009 15.6679 5.31388 15.5093 5.71429 15.2153C6.1147 14.9213 6.41083 14.5072 6.55959 14.0333C6.70835 13.5593 6.70196 13.0502 6.54136 12.5802C6.38076 12.1101 6.07433 11.7035 5.66667 11.4197V1.66634Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10.333H0",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9H1",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7.66602H1",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6.33301H0",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 6.33301H6.66797",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.33301H14",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5H1",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 3.66602H1",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2.33301H0",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 7.99935C12.2551 7.99935 13.0013 7.25316 13.0013 6.33268C13.0013 5.41221 12.2551 4.66602 11.3346 4.66602C10.4142 4.66602 9.66797 5.41221 9.66797 6.33268C9.66797 7.25316 10.4142 7.99935 11.3346 7.99935Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02464 7.66602L7.29297 8.66602",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3742 4L13.6426 5",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.64258L9 10.3742",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.668 2.29199L12.668 4.02366",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.332 9V11",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.332 1.66602V3.66602",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02464 5L7.29297 4",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3742 8.66602L13.6426 7.66602",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.02366L9 2.29199",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.668 10.3742L12.668 8.64258",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightTemp);
export default __webpack_public_path__ + "static/media/heightTemp.3a215a38.svg";
export { ForwardRef as ReactComponent };